
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"25","viewBox":"0 0 25 25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 3C0 1.34315 1.34315 0 3 0H22C23.6569 0 25 1.34315 25 3V22C25 23.6569 23.6569 25 22 25H3C1.34315 25 0 23.6569 0 22V3Z","fill":"#0CB892"}}),_c('path',{attrs:{"d":"M9.44077 8.0536C9.44077 9.27982 8.44672 9.16373 7.2205 9.16373C5.99429 9.16373 5.00024 9.27982 5.00024 8.0536C5.00024 6.82739 5.99429 5.83334 7.2205 5.83334C8.44672 5.83334 9.44077 6.82739 9.44077 8.0536Z","fill":"#096F58"}}),_c('path',{attrs:{"d":"M20.274 8.0536C20.274 9.27982 19.28 9.16373 18.0538 9.16373C16.8275 9.16373 15.8335 9.27982 15.8335 8.0536C15.8335 6.82739 16.8275 5.83334 18.0538 5.83334C19.28 5.83334 20.274 6.82739 20.274 8.0536Z","fill":"#096F58"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.98884 16.5219C10.6973 18.2671 15.0713 18.1342 18.696 16.201L19.6372 17.9657C15.4638 20.1915 10.4255 20.3495 6.13725 18.3316L5.40749 17.9881C4.90777 17.753 4.6933 17.1572 4.92846 16.6575C5.16363 16.1578 5.75936 15.9433 6.25908 16.1785L6.98884 16.5219Z","fill":"#096F58"}})])
          )
        }
      }
    